/**
 * One-line street + house number (matches recipient / patient detail forms).
 * Non-empty values must contain at least one digit (Hausnummer).
 */
export const STREET_WITH_NUMBER_REGEX = /^.*[^\d\s]\s*\d+[\s\w/\-]*$/;

/**
 * Build a single display/save line from optional `street` and legacy numeric `number` (DB).
 */
export function formatStreetAndNumber(
    street?: string | null,
    number?: number | string | null,
): string {
    const s = (street ?? "").trim();
    const nRaw = number == null || number === "" ? "" : String(number).trim();
    if (!s && !nRaw) return "";
    if (!nRaw) return s;
    if (!s) return nRaw;
    const escaped = nRaw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    if (new RegExp(`(?:^|\\s)${escaped}(?:\\s|$)`).test(s)) return s;
    return `${s} ${nRaw}`.replace(/\s+/g, " ").trim();
}
